import {FadeLoader} from 'react-spinners';

const override = `
  display: block;
  margin: 0 auto;
`;

export default function FadeSpinner({loading = true}) {

  return (
    <FadeLoader color={'#A52A2A'} loading={loading} css={override} size={100}/>
  )
}